import React from "react";
import { mergeStyles } from "@fluentui/react";
import { SparkleRegular } from "@fluentui/react-icons";

const warningBar = mergeStyles(
    {
        display: 'flex',
        alignItems: 'center',
        gap: 'var(--druid-space-8)',
        minHeight: 'var(--webchat-editor-warning-height)',
        boxSizing: 'border-box',
        padding: 'var(--druid-space-10) var(--druid-space-24)',
        backgroundColor: 'var(--druid-orange-50)',
        color: 'var(--druid-color-text-primary)',
    }
);

const warningIcon = mergeStyles(
    {
        display: 'inline-flex',
        flex: '0 0 auto',
        fontSize: 20,
        color: 'var(--druid-orange-500)',
    }
);

const warningTitle = mergeStyles(
    {
        fontWeight: 'var(--druid-font-weight-semibold)',
    }
);

const warningDescription = mergeStyles(
    {
        color: 'var(--druid-color-text-secondary)',
        marginLeft: 'var(--druid-space-8)',
    }
);

const warningSpacer = mergeStyles(
    {
        flex: '1 1 auto',
    }
);

const warningButton = mergeStyles(
    {
        flex: '0 0 auto',
        border: 0,
        borderRadius: 'var(--druid-radius-4)',
        padding: 'var(--druid-space-6) var(--druid-space-16)',
        backgroundColor: 'var(--druid-orange-200)',
        color: 'var(--druid-orange-900)',
        fontFamily: 'inherit',
        fontSize: 'inherit',
        fontWeight: 'var(--druid-font-weight-semibold)',
        cursor: 'pointer',
        transition: 'background-color var(--druid-transition-fast) ease',
        selectors: {
            ':hover': {
                backgroundColor: 'var(--druid-orange-300)',
            },
            ':focus-visible': {
                outline: '2px solid var(--druid-orange-500)',
                outlineOffset: '1px',
            },
        },
    }
);

interface SipNotConfiguredWarningProps {
    onConfigureSip?: () => any;
}

export const SipNotConfiguredWarning = (props: SipNotConfiguredWarningProps) => {
    const { onConfigureSip } = props;

    return (
        <div className={warningBar} role="status">
            <span className={warningIcon} aria-hidden={true}><SparkleRegular /></span>
            <span className={warningTitle}>Voice chat not available</span>
            <span className={warningDescription}>SIP channel not configured</span>
            <div className={warningSpacer} />
            {onConfigureSip &&
                <button type="button" className={warningButton} onClick={() => onConfigureSip()}>Configure SIP</button>}
        </div>
    );
}

export default SipNotConfiguredWarning;
